import { apiFetch, ApiBaseUrl } from "./fetch";

export default class ApiDebug {
  static ping({ appSlug, visitorId }) {
    return apiFetch(`${ApiBaseUrl}debug/ping`, {
      query: { app_slug: appSlug, visitor_id: visitorId },
    });
  }
}
